const split = '.';

export const getNsPathnameFromString = (ns, namespaces, depth = 0) => {
  const segments = ns.split(split);
  if (ns === 'fcp_uat.zhidui_3') {
    console.log('segments', segments);
  }
  let current = '';
  const names = segments.map((seg) => {
    current = current ? current + split + seg : seg;
    const match = namespaces.find((item) => item.ns === current);
    return match ? match.name : '';
  });
  return names.slice(depth).join('/');
};

// 输入 ["a1.b1","a2.b2.c2"]，返回 ["a1","a1.b1","a2","a2.b2","a2.b2.c2"]
export function expandPrefixesNs(arr) {
  const seen = new Set();
  return arr
    .flatMap((s) => {
      if (typeof s !== 'string' || s === '') return [];
      const parts = s.split('.');
      return parts.map((_, i) => parts.slice(0, i + 1).join('.'));
    })
    .filter((p) => {
      if (seen.has(p)) return false;
      seen.add(p);
      return true;
    });
}
